// src/components/admin/TorreDeControl/modals/LocationModal.jsx
import React, { useState, useEffect } from 'react';
import { X, MapPin, Navigation } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function LocationModal({ item, itemType, onClose, onUpdate }) {
  const [formData, setFormData] = useState({
    address: '',
    latitude: '',
    longitude: '',
    district: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdatingDriver, setIsUpdatingDriver] = useState(false);

  useEffect(() => {
    if (item) {
      setFormData({
        address: itemType === 'delivery' ? item.address : item.address?.address || '',
        latitude: itemType === 'delivery' ? item.latitude : item.address?.latitude || '',
        longitude: itemType === 'delivery' ? item.longitude : item.address?.longitude || '',
        district: itemType === 'delivery' ? item.district : item.address?.district || '',
      });
    }
  }, [item, itemType]);

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    try {
      const endpoint =
        itemType === 'delivery'
          ? `${API_URL}/api/admin/delivery-point/${item.id}`
          : `${API_URL}/api/admin/order/${item.id}/address`;

      await axios.put(endpoint, formData);
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error updating location:', error);
      alert('Error al actualizar la ubicación');
    } finally {
      setIsLoading(false);
    }
  }

  async function handleUpdateDriverLocation() {
    setIsUpdatingDriver(true);
    try {
      await axios.post(`${API_URL}/api/update_driver_location`, {
        id: item.id,
      });
      alert('Ubicación del motorizado actualizada');
    } catch (error) {
      console.error('Error updating driver location:', error);
      alert(error.response?.data?.error || 'Error al actualizar ubicación del motorizado');
    } finally {
      setIsUpdatingDriver(false);
    }
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
        <div className="bg-[#B1336E] px-6 py-4 flex items-center justify-between">
          <h3 className="text-white font-bold text-lg flex items-center gap-2 font-montserrat">
            <MapPin className="w-5 h-5" />
            Actualizar Ubicación
          </h3>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Dirección
            </label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
                Latitud
              </label>
              <input
                type="number"
                step="any"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
                Longitud
              </label>
              <input
                type="number"
                step="any"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
              />
            </div>
          </div>

          {itemType === 'delivery' && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
                Distrito
              </label>
              <input
                type="text"
                name="district"
                value={formData.district}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
              />
            </div>
          )}

          {item.driver_id && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-blue-800 mb-3 font-montserrat">
                Actualizar ubicación del motorizado a esta ubicación
              </p>
              <button
                type="button"
                onClick={handleUpdateDriverLocation}
                disabled={isUpdatingDriver || !formData.latitude || !formData.longitude}
                className="w-full bg-blue-500 hover:bg-blue-600 disabled:bg-slate-300 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 font-montserrat"
              >
                <Navigation className="w-4 h-4" />
                {isUpdatingDriver ? 'Actualizando...' : 'Actualizar Ubicación Motorizado'}
              </button>
            </div>
          )}

          <div className="flex gap-3 pt-4 border-t border-slate-200">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 bg-[#B1336E] hover:bg-[#B1336E]/90 disabled:bg-slate-300 text-white px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              {isLoading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LocationModal;